<script lang="ts">
	import FormControl from './FormControl.svelte';
	import Hint from './Hint.svelte';
	import type { HTMLInputValidationProps } from '../types/props';
	import Icon from './Icon.svelte';

	export let id: string | null = null;
	export let name: string | null = null;
	export let label: string | null = null;
	export let checked = false;
	export let value: string | null = null;
	export let hint: string | null = null;
	export let disabled = false;
	export let required = false;
	export let validation: HTMLInputValidationProps = { rules: [] };
	export let labelIcon: string | null = null;
	export let classNames: string | null = null;
	export let labelClassNames: string | null = null;
</script>

<FormControl let:autoId {id} value={checked} {required} bind:validation {classNames}>
	<div class="flex items-center select-none">
		<label
			for={id || autoId}
			class="checkbox-label {labelClassNames} inline-flex items-center space-x-2 select-none {hint
				? 'mr-2'
				: ''} {disabled ? 'cursor-not-allowed' : 'cursor-pointer'}"
		>
			<input
				id={id || autoId}
				type="checkbox"
				class="custom-checkbox"
				class:cursor-pointer={!disabled}
				bind:value
				bind:checked
				{disabled}
				{required}
			/>
			{#if labelIcon}
				<Icon name={labelIcon} />
			{/if}
			<span class="checkbox-text">{label}</span>
		</label>
		{#if hint}
			<Hint>
				{hint}
			</Hint>
		{/if}
	</div>
</FormControl>

<style lang="postcss">
	.custom-checkbox {
		@apply inline-block box-border align-middle
    flex-shrink-0 w-4 h-4 p-0 bg-white appearance-none border rounded
    border-grey ring-0 focus:ring-0 focus:ring-transparent;
		background-origin: border-box;
	}

	.custom-checkbox:checked {
		@apply border-transparent bg-secondary bg-center bg-no-repeat;
		background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
		background-size: 100% 100%;
	}

	.custom-checkbox:disabled {
		@apply border-grey-lighter cursor-not-allowed;
	}
</style>
